export const locatorMethods = [
  'getByAltText',
  'getByLabel',
  'getByPlaceholder',
  'getByRole',
  'getByTestId',
  'getByText',
  'getByTitle',
  'locator',
] as const;

export const actionMethods = [
  'blur',
  'check',
  'clear',
  'click',
  'dblclick',
  'dispatchEvent',
  'dragTo',
  'fill',
  'focus',
  'hover',
  'press',
  'type',
  'scroll',
  'scrollIntoViewIfNeeded',
  'selectOption',
  'setInputFiles',
  'tap',
  'type',
  'pressSequentially',
  'uncheck',
  // Include navigation here for now
  'goto',
  'goBack',
  'goForward',
  'waitForTimeout',
  'reload',
  // probably should get moved elsewhere as mobile specific
  'swipe',
] as const;
export const actionMethodsSet = new Set(actionMethods);
export type ActionMethod = (typeof actionMethods)[number];
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const isActionMethod = (x: any): x is ActionMethod => actionMethodsSet.has(x);

export const assertionMethods = [
  'toBeAttached',
  'toBeChecked',
  'toBeDisabled',
  'toBeEditable',
  'toBeEmpty',
  'toBeEnabled',
  'toBeFocused',
  'toBeHidden',
  'toBeInViewport',
  'toBeVisible',
  'toContainText',
  'toHaveAttribute',
  'toHaveClass',
  'toHaveCount',
  'toHaveCSS',
  'toHaveId',
  'toHaveJSProperty',
  'toHaveScreenshot',
  'toHaveText',
  'toHaveValue',
  'toHaveValues',
] as const;
export const assertionMethodsSet = new Set(assertionMethods);
export type AssertionMethod = (typeof assertionMethods)[number];
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const isAssertionMethod = (x: any): x is AssertionMethod => assertionMethodsSet.has(x);
